"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchQueryParam = void 0;
const router_1 = require("next/router");
function useSearchQueryParam(param) {
    const router = (0, router_1.useRouter)();
    return router.query[param];
}
exports.useSearchQueryParam = useSearchQueryParam;
//# sourceMappingURL=next.js.map